import {
  GetSessionProductTreesResponse,
  GetSessionTreesRequest,
} from "@financial-advisory/data-access/api-types";
import { productRecommendationApi } from "./productRecommendationApi";

export const {
  useGetSessionProductTreesQuery,
  useLazyGetSessionProductTreesQuery,
} = productRecommendationApi.injectEndpoints({
  endpoints: (builder) => ({
    getSessionProductTrees: builder.query<
      GetSessionProductTreesResponse,
      GetSessionTreesRequest
    >({
      query: ({ sessionVersionId }) => ({
        url: `sessions/${sessionVersionId}/product-trees`,
        method: "GET",
      }),
    }),
  }),
});
